import {
  REPORTS_PAGE_ROUTE,
  CATALOG_PAGE_ROUTE,
  DASHBOARD_PAGE_ROUTE,
  OUTLET_STATUS_PAGE_ROUTE,
  ACCOUNTING_PAGE_ROUTE,
  DOWNLOADS_PAGE_ROUTE,
  TABLES_PAGE_ROUTE,
  RISTA_CARD_PAGE_ROUTE
} from "./routes-constants";
import { USER_ROLES, TABLES_TABS_MAP, Role } from "./constants";
import { ACCOUNTING_TABS_MAP } from "./accounting-constants";
import { REPORTS_SUBTABS_MAP } from "./reports-constants";
import { SubTabsDataType } from "../layouts/header";

interface navItem {
  icon?: string;
  iconFilled?: string;
  name: string;
  path: string;
  isPremium?: boolean;
  permission?: Role[];
  isThemeEditor?: boolean;
  list?: Array<navItem>;
  subTabsMap?: Record<string, SubTabsDataType>;
  tabIndex: number;
}

export const NAVIGATION_LIST_ITEM = (): Array<navItem> => [
  {
    icon: "rista-sprite ic-dashboard",
    name: `Dashboard`,
    path: DASHBOARD_PAGE_ROUTE,
    tabIndex: 1,
  },
  {
    icon: "rista-sprite ic-reports",
    name: `Reports`,
    path: REPORTS_PAGE_ROUTE,
    tabIndex: 2,
    subTabsMap: REPORTS_SUBTABS_MAP,
  },
  {
    icon: "rista-sprite ic-catalog",
    name: `Catalogue`,
    path: CATALOG_PAGE_ROUTE,
    permission: [USER_ROLES.admin],
    tabIndex: 3,
  },
  {
    icon: "rista-sprite ic-outlet_status",
    name: `Outlet Status`,
    path: OUTLET_STATUS_PAGE_ROUTE,
    tabIndex: 4,
  },
  {
    icon: "rista-sprite ic-accounting",
    name: `Accounting`,
    path: ACCOUNTING_PAGE_ROUTE,
    tabIndex: 5,
    subTabsMap: ACCOUNTING_TABS_MAP,
  },
  {
    icon: "rista-sprite ic-download",
    name: `Downloads`,
    path: DOWNLOADS_PAGE_ROUTE,
    tabIndex: 6
  },
  {
    icon: 'rista-sprite ic-tables-tab',
    name: `Tables`,
    path: TABLES_PAGE_ROUTE,
    tabIndex: 7,
    permission: [USER_ROLES.admin, USER_ROLES.manager],
    subTabsMap: TABLES_TABS_MAP,
  },
  {
    icon: 'rista-sprite ic-rista-cards',
    name: `Rista Cards`,
    path: RISTA_CARD_PAGE_ROUTE,
    tabIndex: 8,
    permission: [USER_ROLES.admin, USER_ROLES.manager],
  }
];
